// pp-calc-checklists.js — Checklists de Almacén para Imprimir
// (/pages/checklists-de-almacen-para-imprimir)
//
// NO es una calculadora: es un imprimible editorial con vista previa, al
// estilo del generador de rótulos (pp-calc-rotulos.js). El almacén elige una
// checklist —Recepción, Empaque o Cierre del Día—, la ve tal cual va a salir
// en hoja carta, y la descarga como PDF o la manda directo a imprimir. Se
// pega en la pared y se palomea a pluma.
//
// Lógica pura (los datos editoriales + estructura de la hoja + el PDF) en
// PPChecklists, probada en tests/calc-checklists.test.mjs. El wiring de DOM
// va aparte, protegido con typeof document.
//
// SEGURIDAD: aunque aquí no hay texto del usuario (las checklists son
// editoriales), la regla de la casa es la misma: todo texto se pinta
// ÚNICAMENTE con textContent/createElement — jamás innerHTML.
(function (root) {
  'use strict';

  // ── Los datos editoriales ───────────────────────────────────────────────
  // Cada checklist: id, titulo, intro de una línea y 8–10 items. Un item es
  // { texto } o { texto, nota } — la nota es la letra chica que apunta a la
  // herramienta hermana. Texto en Title Case / oración: la MAYÚSCULA visual
  // (encabezado de la hoja) la pone el CSS o el canvas, no el dato.
  var CHECKLISTS = [
    {
      id: 'recepcion',
      titulo: 'Recepción de Mercancía',
      intro: 'Antes de firmarle al chofer: lo que se revisa al recibir.',
      items: [
        { texto: 'Contar los bultos contra la factura antes de firmar' },
        { texto: 'Revisar daños visibles y fotografiar cualquier golpe' },
        { texto: 'Pesar 1–2 rollos de emplaye al azar, y su núcleo aparte', nota: 'verifícalo en parapaquetes.com/pages/verificador-de-emplaye' },
        { texto: 'Cotejar calibre y especificaciones contra la orden de compra' },
        { texto: 'Firmar con reservas si algo no cuadra' },
        { texto: 'Etiquetar la mercancía y ubicarla en su rack el mismo día' },
        { texto: 'Registrar la entrada en el sistema' },
        { texto: 'Guardar la factura y las evidencias juntas' }
      ]
    },
    {
      id: 'empaque',
      titulo: 'Empaque sin Errores',
      intro: 'De pedido a paquete, sin vueltas ni reclamos.',
      items: [
        { texto: 'Cotejar SKU y cantidad contra el pedido' },
        { texto: 'Elegir la caja de la medida correcta — no la que esté a la mano' },
        { texto: 'Relleno hasta que nada se mueva (unos 2 cm por lado)' },
        { texto: 'Sellado en U — o en H si pesa más de 5 kg' },
        { texto: 'Etiqueta de envío legible en la cara más grande, nunca sobre una cinta' },
        { texto: 'Rótulo de FRÁGIL si aplica' },
        { texto: 'Pesar el paquete y anotar el peso en el sistema' },
        { texto: 'Separarlo en la zona de salida' }
      ]
    },
    {
      id: 'cierre',
      titulo: 'Cierre del Día',
      intro: 'Cinco minutos hoy que ahorran la mañana entera.',
      items: [
        { texto: 'Pedidos del día: todos empacados o anotados para mañana' },
        { texto: 'Guías recolectadas confirmadas con la paquetería' },
        { texto: 'Revisar stock de insumos contra su punto de reorden', nota: 'calcúlalo en parapaquetes.com/pages/punto-de-reorden-de-insumos' },
        { texto: 'Báscula, cinta y herramientas de vuelta a su lugar' },
        { texto: 'Zona de empaque despejada y lista para mañana' },
        { texto: 'Merma del día registrada' },
        { texto: 'Impresora de etiquetas con rollo suficiente para arrancar' },
        { texto: 'Apagar equipos y cerrar el almacén con llave' }
      ]
    }
  ];

  var PIE = 'parapaquetes.com · Material de Empaque';

  function checklistPorId(id) {
    for (var i = 0; i < CHECKLISTS.length; i++) {
      if (CHECKLISTS[i].id === id) return CHECKLISTS[i];
    }
    return null;
  }

  // Entradas: { checklist } → la hoja completa lista para pintar:
  // { id, titulo, intro, items, pie }. Default sensato: la primera checklist.
  // Id desconocido → null (no una hoja basura).
  function armarHoja(e) {
    var c;
    if (!e || e.checklist === undefined || e.checklist === null || e.checklist === '') {
      c = CHECKLISTS[0];
    } else {
      c = checklistPorId(e.checklist);
    }
    if (!c) return null;
    return { id: c.id, titulo: c.titulo, intro: c.intro, items: c.items, pie: PIE };
  }

  // El string del @page que el wiring inyecta. Puro para poderlo probar.
  // Margin 0 SIEMPRE (lección del QA de rótulos, 1-sep): sin margen, Chrome
  // no tiene dónde pintar su fecha y su URL — el margen visual de la carta
  // lo pone el padding de la hoja en el CSS de impresión.
  function paginaCss() {
    return '@page { size: letter portrait; margin: 0; }';
  }

  // Tamaño de página en puntos (1 in = 72 pt). La checklist siempre es carta.
  var PUNTOS = {
    carta: { w: 612, h: 792 }
  };

  // ── PDF hecho en casa ─────────────────────────────────────────────────
  // COPIA 1:1 de PPRotulos.pdfConImagen (assets/pp-calc-rotulos.js).
  // NO tocar aquí sin tocar allá — tests/calc-checklists.test.mjs compara
  // los bytes de las dos copias y truena si divergen.
  //
  // Construye los bytes de un PDF 1.4 de UNA página con el JPEG a página
  // completa. jpegBytes: Uint8Array; wPt/hPt: página en puntos; wPx/hPx:
  // pixeles del JPEG. Puro: probado en node con bytes sintéticos.
  function pdfConImagen(jpegBytes, wPt, hPt, wPx, hPx) {
    var enc = new TextEncoder();
    var contenido = 'q ' + wPt + ' 0 0 ' + hPt + ' 0 0 cm /Im1 Do Q';
    var objs = [
      '<< /Type /Catalog /Pages 2 0 R >>',
      '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
      '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + wPt + ' ' + hPt + '] /Resources << /XObject << /Im1 4 0 R >> >> /Contents 5 0 R >>',
      null, // el 4 es la imagen, va aparte por el stream binario
      '<< /Length ' + contenido.length + ' >>\nstream\n' + contenido + '\nendstream'
    ];
    var partes = [];
    var offset = 0;
    var offsets = [];
    function put(bytes) { partes.push(bytes); offset += bytes.length; }
    put(enc.encode('%PDF-1.4\n'));
    for (var i = 0; i < objs.length; i++) {
      offsets[i] = offset;
      if (i === 3) {
        put(enc.encode('4 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + wPx + ' /Height ' + hPx +
          ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpegBytes.length + ' >>\nstream\n'));
        put(jpegBytes);
        put(enc.encode('\nendstream\nendobj\n'));
      } else {
        put(enc.encode((i + 1) + ' 0 obj\n' + objs[i] + '\nendobj\n'));
      }
    }
    var xrefPos = offset;
    var xref = 'xref\n0 6\n0000000000 65535 f \n';
    for (var j = 0; j < 5; j++) {
      xref += String(offsets[j]).padStart(10, '0') + ' 00000 n \n';
    }
    put(enc.encode(xref + 'trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xrefPos + '\n%%EOF'));
    var total = new Uint8Array(offset);
    var pos = 0;
    for (var k = 0; k < partes.length; k++) { total.set(partes[k], pos); pos += partes[k].length; }
    return total;
  }

  // Nombre de archivo amable, con la limpieza de acentos del patrón de
  // rótulos: "Checklist Recepcion de Mercancia - Para Paquetes.pdf"
  function nombreArchivo(titulo) {
    var limpio = String(titulo).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Za-z0-9 -]/g, '').trim().slice(0, 40);
    return 'Checklist ' + limpio + ' - Para Paquetes.pdf';
  }

  root.PPChecklists = {
    CHECKLISTS: CHECKLISTS,
    PIE: PIE,
    PUNTOS: PUNTOS,
    checklistPorId: checklistPorId,
    armarHoja: armarHoja,
    paginaCss: paginaCss,
    pdfConImagen: pdfConImagen,
    nombreArchivo: nombreArchivo
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-checklists]');
    if (!raiz) return;
    var C = window.PPChecklists;
    var form = raiz.querySelector('form');
    var hojaEl = raiz.querySelector('[data-checklist-hoja]');
    var botonImprimir = raiz.querySelector('[data-imprimir]');
    var botonDescargar = raiz.querySelector('[data-descargar]');
    if (!form || !hojaEl) return;

    // @page no puede depender de una clase: este <style> propio lleva la
    // carta sin margen, y se muda al final del documento antes de imprimir.
    var estiloPagina = document.createElement('style');
    estiloPagina.textContent = C.paginaCss();
    document.head.appendChild(estiloPagina);

    function hojaActual() {
      var f = new FormData(form);
      return C.armarHoja({ checklist: f.get('checklist') });
    }

    // ── Vista previa ──────────────────────────────────────────────────────
    // Todo con createElement/textContent — cero innerHTML.
    function pintarHoja(hoja) {
      hojaEl.textContent = '';
      hojaEl.dataset.checklist = hoja.id;

      var cabecera = document.createElement('div');
      cabecera.className = 'pp-checklist__cabecera';
      var titulo = document.createElement('p');
      titulo.className = 'pp-checklist__titulo';
      titulo.textContent = hoja.titulo;
      cabecera.appendChild(titulo);
      hojaEl.appendChild(cabecera);

      var meta = document.createElement('div');
      meta.className = 'pp-checklist__meta';
      var campos = ['Fecha', 'Responsable'];
      for (var m = 0; m < campos.length; m++) {
        var campo = document.createElement('span');
        campo.className = 'pp-checklist__meta-campo';
        var etiqueta = document.createElement('span');
        etiqueta.className = 'pp-checklist__meta-etiqueta';
        etiqueta.textContent = campos[m];
        var linea = document.createElement('span');
        linea.className = 'pp-checklist__meta-linea';
        campo.appendChild(etiqueta);
        campo.appendChild(linea);
        meta.appendChild(campo);
      }
      hojaEl.appendChild(meta);

      var intro = document.createElement('p');
      intro.className = 'pp-checklist__intro';
      intro.textContent = hoja.intro;
      hojaEl.appendChild(intro);

      var lista = document.createElement('ul');
      lista.className = 'pp-checklist__items';
      for (var i = 0; i < hoja.items.length; i++) {
        var item = hoja.items[i];
        var li = document.createElement('li');
        li.className = 'pp-checklist__item';
        var casilla = document.createElement('span');
        casilla.className = 'pp-checklist__casilla';
        casilla.setAttribute('aria-hidden', 'true');
        li.appendChild(casilla);
        var cuerpo = document.createElement('span');
        cuerpo.className = 'pp-checklist__item-cuerpo';
        var texto = document.createElement('span');
        texto.className = 'pp-checklist__item-texto';
        texto.textContent = item.texto;
        cuerpo.appendChild(texto);
        if (item.nota) {
          var nota = document.createElement('span');
          nota.className = 'pp-checklist__item-nota';
          nota.textContent = item.nota;
          cuerpo.appendChild(nota);
        }
        li.appendChild(cuerpo);
        lista.appendChild(li);
      }
      hojaEl.appendChild(lista);

      var pie = document.createElement('p');
      pie.className = 'pp-checklist__pie';
      pie.textContent = hoja.pie;
      hojaEl.appendChild(pie);
    }

    function render() {
      var hoja = hojaActual();
      if (!hoja) return;
      pintarHoja(hoja);
    }

    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', function (ev) { ev.preventDefault(); });

    // ── Impresión real ────────────────────────────────────────────────────
    // Patrón del generador de rótulos: la hoja se MUEVE a ser hija directa
    // de <body> mientras se imprime (beforeprint) y se regresa a su lugar
    // con un marcador de comentario (afterprint). Así el documento impreso
    // es SOLO la checklist — una página, sin el resto del layout ocupando
    // altura invisible. Cubre tanto nuestro botón como Cmd+P.
    var marcador = document.createComment('pp-checklist-hoja-va-aqui');
    var tituloOriginal = document.title;
    function alImprimir() {
      if (!hojaEl.parentNode || hojaEl.parentNode === document.body) return;
      hojaEl.parentNode.insertBefore(marcador, hojaEl);
      document.body.appendChild(hojaEl);
      document.body.classList.add('pp-imprimiendo-checklist');
      // El @page nuestro se muda al FINAL del documento justo antes de
      // imprimir: los CSS de apps se inyectan después del nuestro y un
      // @page ajeno le ganaría por orden (lección de rótulos, 1-sep).
      document.body.appendChild(estiloPagina);
      // El nombre del PDF sale del título del documento — que diga qué es.
      var hoja = hojaActual();
      if (hoja) document.title = 'Checklist ' + hoja.titulo + ' — Para Paquetes';
    }
    function alTerminar() {
      if (marcador.parentNode) {
        marcador.parentNode.insertBefore(hojaEl, marcador);
        marcador.parentNode.removeChild(marcador);
      }
      document.body.classList.remove('pp-imprimiendo-checklist');
      document.title = tituloOriginal;
    }
    window.addEventListener('beforeprint', alImprimir);
    window.addEventListener('afterprint', alTerminar);

    if (botonImprimir) {
      botonImprimir.addEventListener('click', function () { window.print(); });
    }

    // ── Descargar PDF (el camino recomendado) ────────────────────────────
    // Rasteriza la hoja carta a 300 dpi en un canvas —texto multilinea con
    // las casillas dibujadas— y la empaca en el PDF mínimo de
    // PPChecklists.pdfConImagen a 612×792 pt. Del PDF descargado, cualquier
    // impresora sale bien.
    var DPI = 300;
    var NAVY = '#0E3A5C';
    var INK = '#1f2937';
    var GRIS = '#6b7280';
    var FUENTE = '"Inter Tight", -apple-system, sans-serif';

    // Greedy por palabras, mismo enfoque que el rasterizador de rótulos.
    function partirLineas(ctx, texto, anchoMax) {
      var palabras = String(texto).split(/\s+/).filter(Boolean);
      var lineas = [];
      var actual = '';
      for (var i = 0; i < palabras.length; i++) {
        var candidata = actual ? actual + ' ' + palabras[i] : palabras[i];
        if (ctx.measureText(candidata).width <= anchoMax || !actual) { actual = candidata; }
        else { lineas.push(actual); actual = palabras[i]; }
      }
      if (actual) lineas.push(actual);
      return lineas;
    }

    function rasterizar(hoja) {
      var pts = C.PUNTOS.carta;
      var esc = DPI / 72;
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(pts.w * esc);   // 2550
      canvas.height = Math.round(pts.h * esc);  // 3300
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var margen = Math.round(14 / 25.4 * DPI); // 14 mm → px
      var anchoUtil = canvas.width - 2 * margen;
      var y = margen;

      // Encabezado navy con el título en blanco
      var altoCabecera = Math.round(canvas.height * 0.075);
      ctx.fillStyle = NAVY;
      ctx.fillRect(margen, y, anchoUtil, altoCabecera);
      var tamTitulo = Math.round(altoCabecera * 0.38);
      ctx.font = '800 ' + tamTitulo + 'px ' + FUENTE;
      while (tamTitulo > 24 && ctx.measureText(hoja.titulo).width > anchoUtil - 2 * 60) {
        tamTitulo = Math.round(tamTitulo * 0.94);
        ctx.font = '800 ' + tamTitulo + 'px ' + FUENTE;
      }
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillText(hoja.titulo, margen + 60, y + altoCabecera / 2, anchoUtil - 120);
      y += altoCabecera + 90;

      // Fecha ____ Responsable ____ (para llenar a pluma)
      var tamMeta = 52;
      ctx.font = '600 ' + tamMeta + 'px ' + FUENTE;
      ctx.fillStyle = INK;
      ctx.textBaseline = 'alphabetic';
      ctx.strokeStyle = GRIS;
      ctx.lineWidth = 3;
      var xMeta = margen + 10;
      var campos = ['Fecha', 'Responsable'];
      for (var cm = 0; cm < campos.length; cm++) {
        var etiqueta = campos[cm];
        ctx.fillText(etiqueta, xMeta, y);
        var wEtiqueta = ctx.measureText(etiqueta).width;
        var xLinea = xMeta + wEtiqueta + 24;
        var wLinea = cm === 0 ? 460 : margen + anchoUtil - 10 - xLinea;
        ctx.beginPath();
        ctx.moveTo(xLinea, y + 10);
        ctx.lineTo(xLinea + wLinea, y + 10);
        ctx.stroke();
        xMeta = xLinea + wLinea + 70;
      }
      y += tamMeta + 60;

      // Intro de una línea, en gris
      var tamIntro = 46;
      ctx.font = '400 ' + tamIntro + 'px ' + FUENTE;
      ctx.fillStyle = GRIS;
      ctx.fillText(hoja.intro, margen + 10, y, anchoUtil - 20);
      y += tamIntro + 40;

      // Los items: casilla cuadrada vacía + texto multilinea + nota chica.
      // Primero se mide todo, luego se reparte el aire que sobre para que la
      // hoja se sienta diseñada y no amontonada arriba.
      var tamItem = 54;
      var lineaItem = Math.round(tamItem * 1.35);
      var tamNota = 40;
      var lineaNota = Math.round(tamNota * 1.3);
      var casilla = 66;
      var gapCasilla = 40;
      var xTexto = margen + 10 + casilla + gapCasilla;
      var anchoTexto = margen + anchoUtil - 10 - xTexto;
      var limiteY = canvas.height - margen - 110; // aire para el pie

      var medidas = [];
      var altoTotal = 0;
      for (var i = 0; i < hoja.items.length; i++) {
        ctx.font = '500 ' + tamItem + 'px ' + FUENTE;
        var lineas = partirLineas(ctx, hoja.items[i].texto, anchoTexto);
        var lineasNota = [];
        if (hoja.items[i].nota) {
          ctx.font = '400 ' + tamNota + 'px ' + FUENTE;
          lineasNota = partirLineas(ctx, hoja.items[i].nota, anchoTexto);
        }
        var alto = lineas.length * lineaItem + lineasNota.length * lineaNota;
        medidas.push({ lineas: lineas, lineasNota: lineasNota, alto: alto });
        altoTotal += alto;
      }
      var aire = (limiteY - y - altoTotal) / hoja.items.length;
      aire = Math.max(28, Math.min(110, aire));

      ctx.textBaseline = 'top';
      for (var it = 0; it < medidas.length; it++) {
        var med = medidas[it];
        // La casilla, alineada con la primera línea del texto
        ctx.strokeStyle = NAVY;
        ctx.lineWidth = 6;
        ctx.strokeRect(margen + 10 + 3, y + Math.round((lineaItem - casilla) / 2) + 3, casilla - 6, casilla - 6);
        ctx.fillStyle = INK;
        ctx.font = '500 ' + tamItem + 'px ' + FUENTE;
        var yLinea = y;
        for (var ln = 0; ln < med.lineas.length; ln++) {
          ctx.fillText(med.lineas[ln], xTexto, yLinea + Math.round((lineaItem - tamItem) / 2), anchoTexto);
          yLinea += lineaItem;
        }
        if (med.lineasNota.length) {
          ctx.fillStyle = GRIS;
          ctx.font = '400 italic ' + tamNota + 'px ' + FUENTE;
          for (var nl = 0; nl < med.lineasNota.length; nl++) {
            ctx.fillText(med.lineasNota[nl], xTexto, yLinea + Math.round((lineaNota - tamNota) / 2), anchoTexto);
            yLinea += lineaNota;
          }
        }
        y = yLinea + aire;
      }

      // Pie de marca, discreto y centrado
      ctx.fillStyle = GRIS;
      ctx.font = '400 40px ' + FUENTE;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fillText(hoja.pie, canvas.width / 2, canvas.height - margen, anchoUtil);

      return { canvas: canvas, wPt: pts.w, hPt: pts.h };
    }

    function descargar() {
      var hoja = hojaActual();
      if (!hoja) return;
      var listoFuentes = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      listoFuentes
        .then(function () {
          var r = rasterizar(hoja);
          var dataUrl = r.canvas.toDataURL('image/jpeg', 0.92);
          var b64 = dataUrl.split(',')[1];
          var bin = atob(b64);
          var jpeg = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) jpeg[i] = bin.charCodeAt(i);
          var pdf = C.pdfConImagen(jpeg, r.wPt, r.hPt, r.canvas.width, r.canvas.height);
          var blob = new Blob([pdf], { type: 'application/pdf' });
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = C.nombreArchivo(hoja.titulo);
          document.body.appendChild(a);
          a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
        })
        .catch(function () { window.print(); }); // si algo truena, el plan B es imprimir
    }

    if (botonDescargar) {
      botonDescargar.addEventListener('click', descargar);
    }

    render();
  });
})();
